<script lang="ts">
import { classname } from '@/js/utils.js';

const classBaseInputSwitch = classname('base-input-switch');
export default {
  name: 'BaseInputSwitch',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      checked: this.modelValue,
    };
  },
  watch: {
    modelValue() {
      this.checked = this.modelValue;
    },
  },
  methods: {
    classBaseInputSwitch,
    emitInput() {
      this.$emit('update:modelValue', this.checked);
    },
  },
};
</script>

<template>
  <label :class="classBaseInputSwitch()">
    <slot />
    <span :class="classBaseInputSwitch('inner')">
      <input
        v-model="checked"
        :class="classBaseInputSwitch('input')"
        type="checkbox"
        @change="emitInput"
      >
      <span :class="classBaseInputSwitch('slider', { type: 'round' })" />
    </span>
  </label>
</template>

<style lang="scss">
.base-input-switch {
  display: flex;
  grid-gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;

  &__inner {
    position: relative;
    display: inline-block;
    flex-shrink: 0;
    width: 35px;
    height: 20px;
  }

  &__input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  &__slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #c4c4c4;
    -webkit-transition: 0.4s;
    transition: 0.4s;

    &::before {
      position: absolute;
      content: '';
      height: 18px;
      width: 18px;
      left: 1px;
      bottom: 1px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    &_type {
      &_round {
        border-radius: 21px;

        &::before {
          border-radius: 50%;
        }
      }
    }
  }

  &__input:checked + &__slider {
    background-color: #3962b2;
  }

  &__input:focus + &__slider {
    box-shadow: 0 0 1px #2196f3;
  }

  &__input:checked + &__slider::before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }
}
</style>
